// src/components/Footer.tsx
import React from "react";
import { Link } from "react-router-dom";
import NewsletterForm from "./NewsletterForm";
const Footer: React.FC = () => {
  const infoLinks = [
    { name: "Home", path: "/" },
    { name: "Covid-19 outbreak", path: "/covid-info" },
    { name: "About Us", path: "/about-us" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Contact Us", path: "/contact-us" },
    { name: "Terms and Conditions", path: "/terms-and-conditions" },
    { name: "Delivery Policy", path: "/delivery-policy" },
    { name: "Cancellation & Refund Policy", path: "/cancellation-refund-policy" },
    { name: "FAQ", path: "/faq" },
    { name: "Disclaimer", path: "/disclaimer" },
  ];

  const servicesLinks = [
    { name: "Flights", path: "/booking" },
    { name: "Hotels", path: "/hotels" },
    { name: "Car Hire", path: "/car-hire" },
    { name: "Travel Insurance", path: "/travel-insurance" },
    { name: "Survey", path: "/survey" },
    
  ];

  const toursLinks = [
    { name: "Jambo, Kenya Tour", path: "/tours/kenya" },
    { name: "Kandy & Colombo Tour", path: "/tours/sri-lanka" },
    { name: "Explore Cairo", path: "/tours/egypt" },
  ];

  return (
    <footer
      style={{
        backgroundColor: "#000",
        color: "#fff",
        padding: "3rem 1rem",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "auto",
          display: "flex",
          flexWrap: "wrap",
          gap: "2rem",
          justifyContent: "space-between",
        }}
      >
        {/* Information Links */}
        <div style={{ flex: "1 1 200px", minWidth: 180 }}>
          <h3>Information</h3>
          <ul style={{ listStyle: "none", padding: 0, lineHeight: 1.8 }}>
            {infoLinks.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.path}
                  style={{ color: "white", textDecoration: "none" }}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#ffcc00")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "white")}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services Links */}
        <div style={{ flex: "1 1 200px", minWidth: 180 }}>
          <h3>Services</h3>
          <ul style={{ listStyle: "none", padding: 0, lineHeight: 1.8 }}>
            {servicesLinks.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.path}
                  style={{ color: "white", textDecoration: "none" }}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#ffcc00")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "white")}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Tours Links */}
        <div style={{ flex: "1 1 200px", minWidth: 180 }}>
          <h3>Popular Tours</h3>
          <ul style={{ listStyle: "none", padding: 0, lineHeight: 1.8 }}>
            {toursLinks.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.path}
                  style={{ color: "white", textDecoration: "none" }}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#ffcc00")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "white")}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Newsletter */}
        {/* <div style={{ flex: "1 1 300px", minWidth: 280 }}>
          <h3>Subscribe to our Newsletter</h3>
          <p>Get travel inspiration and offers delivered to your inbox.</p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              alert("Thank you for subscribing!");
            }}
            style={{ marginTop: "1rem", display: "flex", gap: "0.5rem" }}
          >
            <input
              type="email"
              placeholder="Enter Email"
              required
              style={{
                flex: "1",
                padding: "0.5rem",
                borderRadius: "4px",
                border: "none",
                fontSize: "1rem",
              }}
            />
            <button
              type="submit"
              style={{
                padding: "0.5rem 1rem",
                backgroundColor: "#ffcc00",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Subscribe
            </button>
          </form>
        </div> */}
        <NewsletterForm />
      </div>

      <hr style={{ borderColor: "#444", margin: "2rem 0" }} />

      <p style={{ textAlign: "center", fontSize: "0.9rem", opacity: 0.7 }}>
        All Rights Reserved © The Destination Dreams Travel
      </p>
    </footer>
  );
};

export default Footer;
